'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UINotificationBadge = require('UIComponents/badge/UINotificationBadge');

var _UINotificationBadge2 = _interopRequireDefault(_UINotificationBadge);

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _FadeTransition = require('conversations-core/components/transition/FadeTransition');

var _FadeTransition2 = _interopRequireDefault(_FadeTransition);

var _color = require('conversations-core/utils/color');

var _ColoringRecord = require('conversations-schema/records/ColoringRecord');

var _ColoringRecord2 = _interopRequireDefault(_ColoringRecord);

var _AvatarSize = require('conversations-core/constants/AvatarSize');

var _AvatarSize2 = _interopRequireDefault(_AvatarSize);

var _LauncherTypes = require('conversations-schema/constants/LauncherTypes');

var _LauncherTypes2 = _interopRequireDefault(_LauncherTypes);

var _images = require('conversations-core/constants/images');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AVATAR = _LauncherTypes2.default.AVATAR,
    ICON = _LauncherTypes2.default.ICON;
exports.default = _react2.default.createClass({
  displayName: 'Launcher',

  propTypes: {
    onOpen: _react.PropTypes.func.isRequired,
    onClose: _react.PropTypes.func.isRequired,
    open: _react.PropTypes.bool.isRequired,
    coloring: _react.PropTypes.instanceOf(_ColoringRecord2.default).isRequired,
    avatar: _react.PropTypes.string,
    type: _react.PropTypes.oneOf(Object.keys(_LauncherTypes2.default)),
    className: _react.PropTypes.string,
    showBadge: _react.PropTypes.bool,
    badgeNumber: _react.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onOpen: _reactUtils.emptyFunction,
      onClose: _reactUtils.emptyFunction,
      open: false,
      type: ICON
    };
  },
  handleLaunch: function handleLaunch() {
    var _props = this.props,
        onOpen = _props.onOpen,
        onClose = _props.onClose,
        open = _props.open;


    if (open) {
      onClose();
    } else {
      onOpen();
    }
  },
  getIcon: function getIcon(open, isDark) {
    if (open) {
      if (isDark) {
        return _images.launcherClosedDark;
      }
      return _images.launcherClosed;
    }

    if (isDark) {
      return _images.launcherOpenDark;
    }
    return _images.launcherOpen;
  },
  renderAvatar: function renderAvatar() {
    var _props2 = this.props,
        open = _props2.open,
        avatar = _props2.avatar;


    var className = (0, _reactUtils.classNames)('widget-launcher-icon', 'launcher-avatar', {
      close: open,
      open: !open
    });

    return _react2.default.createElement(_UISimpleAvatar2.default, {
      className: className,
      src: avatar,
      size: _AvatarSize2.default.MEDIUM
    });
  },
  renderIcon: function renderIcon() {
    var _props3 = this.props,
        open = _props3.open,
        useDefaultColor = _props3.coloring.useDefaultColor;


    var iconClassName = (0, _reactUtils.classNames)('widget-launcher-icon', {
      close: open,
      open: !open
    });

    var icon = this.getIcon(open, useDefaultColor);
    var key = open ? 'launcher-close-icon' : 'launcher-open-icon';

    return _react2.default.createElement(_UIImage2.default, { className: iconClassName, src: icon, key: key });
  },
  renderIconOrAvatar: function renderIconOrAvatar() {
    var _props4 = this.props,
        open = _props4.open,
        avatar = _props4.avatar,
        type = _props4.type;


    if (!open && type === AVATAR && avatar) {
      return this.renderAvatar();
    }

    return this.renderIcon();
  },
  renderLauncher: function renderLauncher() {
    var _props5 = this.props,
        showBadge = _props5.showBadge,
        badgeNumber = _props5.badgeNumber;


    if (showBadge) {
      return _react2.default.createElement(
        _UINotificationBadge2.default,
        {
          badgeLabel: badgeNumber,
          className: 'notification-badge',
          placement: 'inset'
        },
        this.renderIconOrAvatar()
      );
    }
    return this.renderIconOrAvatar();
  },
  render: function render() {
    var _props6 = this.props,
        accentColor = _props6.coloring.accentColor,
        className = _props6.className;


    return _react2.default.createElement(
      'div',
      _extends({}, (0, _color.getBrandClassNameAndStyle)(accentColor, (0, _reactUtils.classNames)('widget-launcher reagan--widget-loaded', className)), {
        onClick: this.handleLaunch
      }),
      _react2.default.createElement(
        _FadeTransition2.default,
        null,
        this.renderLauncher()
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/widget/Launcher.js
// module id = 279
// module chunks = 0 1